var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconWave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 347.44 162.03"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M146.67 95.48Q57.26 61.19 0 105.27V162h347.44V48.15C277.06 46.74 236.55 130 146.67 95.48",
  className: "icon-wave_svg__cls-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M135.71 67.39Q48.74 49.09 0 70.18V162h347.44V0C274-1.09 242.55 89.89 135.71 67.39",
  className: "icon-wave_svg__cls-2"
})));
export default SvgIconWave;